// base
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// types
import type { I_Notification } from '../interfaces'
// constants
import { FetchStatus } from '../config/configuration'
// service
import { fetchAllNotifications } from './notifications'

export interface NotificationsState {
  readonly items: Array<I_Notification>
  readonly status: FetchStatus | null
  readonly error: string | null
}

const initialState: NotificationsState = {
  items: [],
  status: null,
  error: null
}

export const getAllNotifications = createAsyncThunk(
  'notifications/getAll',
  async (_, _thunkAPI) => {
    try {
      const response = await fetchAllNotifications()
      return response
    } catch (error) {
      console.error(error)
      return Promise.reject(error instanceof Error ? error.message : 'An unknown error occurred')
    }
  }
)

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    markAllRead: (state) => {
      state.items = state.items.map(item => ({ ...item, IsRead: true }))
    },
    clearAllNotifications: (state) => {
      state.items = []
    },
    markOneRead: (state, action) => {
      const index = state.items.findIndex(item => item.ItemID === action.payload)
      if (index !== -1) {
        state.items[index] = { ...state.items[index], IsRead: true }
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllNotifications.pending, (state) => {
        state.status = FetchStatus.LOADING
      })
      .addCase(getAllNotifications.fulfilled, (state, action) => {
        state.status = FetchStatus.SUCCESS
        state.items = action.payload ?? []
      })
      .addCase(getAllNotifications.rejected, (state, action) => {
        state.status = FetchStatus.FAILED
        state.error = action.error.message ?? null
      })
  }
})

export const { markAllRead, clearAllNotifications, markOneRead } = notificationsSlice.actions
export default notificationsSlice.reducer
